import { defineStore } from "pinia";
import { ref, onServerPrefetch, onMounted, watch, computed, getCurrentInstance } from "vue";
import SearchSpringAPI from "@/helpers/api/SearchSpringAPI";
import { useCampaign } from "@/helpers/composables/searchSpringApi";
import { useToggle } from "@/helpers/composables/toggle";
import he from "he";
import useProductVariantSwatches from "@/helpers/composables/productVariantSwatches";
import { attemptServerPrefetch } from "@/helpers/composables/attemptServerPrefetch";
export const useTypeAheadStore = defineStore('typeAhead', ()=>{
    let inputValue = ref("");
    let express = ref(false);
    let searchSpringApi = new SearchSpringAPI();

    let autocompleteSearchSpringApi = new SearchSpringAPI();
    let input = ref();
    const { productVariants, numberOfColors } = useProductVariantSwatches();

    const { data: featuredItems } = useCampaign({
        tag: 'featured-content',
        searchSpringApi
    })
    const typeAheadResults = ref({
        autocomplete: {
            results: []
        },
        trendingSearches: {
            trending: {
                queries: []
            }
        }
    }) 

    const { isOpen, toggle, open, close } = useToggle();

    if(getCurrentInstance()){
 
        attemptServerPrefetch(async ()=>{
            typeAheadResults.value.trendingSearches =
                await searchSpringApi.trendingSearches();
        })
    }

    const isStyleNumber = computed(() => {
        return checkIsStyleNumber(inputValue.value);
    });


    function checkIsStyleNumber(value: string){
        return /^\d+$/.test(value);
    }

    watch(inputValue, async () => {
        if (inputValue.value.length > 2) {
         
            if (!isOpen?.value) {
                toggle();
            }
            typeAheadResults.value.autocomplete =
                await autocompleteSearchSpringApi.autocomplete({
                    searchTerm: inputValue.value
                });
            typeAheadResults.value.suggestions =
                await searchSpringApi.suggestions({
                    searchTerm: inputValue.value
                });
        }else {
            typeAheadResults.value.autocomplete = {
                results: []
            };
            typeAheadResults.value.suggestions = {
                results: []
            };
            
        }
    });

    const popularSearches = computed(() => {
        return typeAheadResults.value.trendingSearches?.trending?.queries ?? [];
    })

    const isSearching = computed(() => {
        return inputValue.value.length > 2 && !isStyleNumber.value;
    });

    const autocompleteResults = computed(() => {
        let arr = [];
        if(!isSearching.value){
            arr = featuredItems.value.results ?? [];
        }else{
            arr = typeAheadResults.value.autocomplete.results;
        }
        
        return arr.map((item) => {
            const variants = productVariants(item.variants);
            const numOfColors = numberOfColors(variants);
            return {
                ...item,
                name: he.decode(item.name),
                true_category: item.category,
                category: formatCategory(item.category?? "")?.split?.('>')?.pop() ?? '',
                variants,
                numberOfColors: numOfColors > 1 ? numOfColors : 1
            }
        })
    });

    const suggestedResults = computed(() => {
        const arr = [];

        arr.push(...(typeAheadResults.value?.suggestions?.suggested?.completed ?? []))

        return arr;
    })
    function formatCategory(category: string){
        return he.decode(category);
    }
    const trueRelatedCategories = computed(() => {
        let arr = autocompleteResults.value.map((item) => item.true_category);
        // get first 3 values
        arr = arr.slice(0, 3);
        return [...new Set(arr)];
    });

    const relatedCategories = computed(()=>{
        let arr = autocompleteResults.value.map((item) => item.category);
        // get first 3 values
        arr = arr.slice(0, 3);
        return [...new Set(arr)];
    })


    function blurTypeAhead(){
        if(document.activeElement.id.startsWith('typeAheadSearch')){
            //blur
            document.activeElement.blur();
        }
    }

    const mobileMouseTracker = ref({
        typeaheadInput: false,
        typeaheadResults: false
    });

    return { typeAheadResults, inputValue, isStyleNumber, checkIsStyleNumber, popularSearches, autocompleteResults, suggestedResults, isSearching, featuredItems, toggle, open, close, isOpen, relatedCategories, trueRelatedCategories, formatCategory, blurTypeAhead, input, express, mobileMouseTracker };
    
});